import script from "./CheckoutView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutView.vue?vue&type=script&setup=true&lang=ts"

import "./CheckoutView.vue?vue&type=style&index=0&id=fbdb7784&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbdb7784"]])

export default __exports__